module.exports = __webpack_public_path__ + "img/paypal.7c552892.svg";